import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { TranslationTag } from '@swf/core/types/i18n';

import {
  mainTitle,
  optionIcon,
  optionText,
  optionWrapper,
  optionsGroup
} from '../DocumentRequirements.scss';

type SVGProps = React.SVGAttributes<SVGElement>;

export interface Props {
  title: TranslationTag;
  options: TranslationTag[];
  icon?: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps>>;
  i18nSystemName: string;
}

const DocumentsGroup: React.FC<Props> = ({ title, options, icon, i18nSystemName }) => (
  <div>
    <p className={mainTitle}>
      <Translation {...title} />
    </p>
    <div className={optionsGroup}>
      {options.map((option, index: number) => (
        <div key={index} className={optionWrapper}>
          <div className={optionIcon}>{icon}</div>
          <p className={optionText}>
            <Translation {...option} values={{ 0: i18nSystemName }} />
          </p>
        </div>
      ))}
    </div>
  </div>
);

export default DocumentsGroup;
